module.exports = __webpack_public_path__ + "img/speedometer.16df69ac.svg";